(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.messages = Array.from(this.querySelectorAll('.announcement__message'));
      if (this.messages.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.index = 0;
      const interval = Number(this.dataset.interval) || 4000;
      this.timer = setInterval(() => this.advance(), interval);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    advance() {
      this.messages[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.messages.length;
      this.messages[this.index].classList.add('is-active');
    }
  }

  customElements.define('announcement-rotator', AnnouncementRotator);

  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      const repeatMinutes = Number(this.dataset.repeatMinutes);
      this.duration = Number.isFinite(repeatMinutes) && repeatMinutes > 0 ? repeatMinutes * 60000 : 0;
      this.deadline = this.duration ? Date.now() + this.duration : Date.parse(this.dataset.deadline);
      if (Number.isNaN(this.deadline)) return;
      this.units = {
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        seconds: this.querySelector('[data-unit="seconds"]'),
      };
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      let remaining = this.deadline - Date.now();
      if (remaining <= 0) {
        if (!this.duration) {
          this.hidden = true;
          clearInterval(this.interval);
          return;
        }
        this.deadline += (Math.floor(-remaining / this.duration) + 1) * this.duration;
        remaining = this.deadline - Date.now();
      }
      const total = Math.ceil(remaining / 1000);
      const pad = (n) => String(n).padStart(2, '0');
      this.units.hours.textContent = pad(Math.floor(total / 3600));
      this.units.minutes.textContent = pad(Math.floor((total % 3600) / 60));
      this.units.seconds.textContent = pad(total % 60);
      this.hidden = false;
    }
  }

  customElements.define('countdown-timer', CountdownTimer);

  /* The header sticks below this bar, so its real height drives the offset rather than a fixed token. */
  const bar = document.querySelector('.announcement');
  if (bar) {
    const syncHeight = () =>
      document.documentElement.style.setProperty('--announcement-h', `${Math.round(bar.getBoundingClientRect().height)}px`);
    syncHeight();
    if ('ResizeObserver' in window) new ResizeObserver(syncHeight).observe(bar);
    else window.addEventListener('resize', syncHeight);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buy-box"] && !Shopify.designMode) return;
  try {
    
  function choosePlan(form, variant, plans) {
    if (form.querySelector('.buybox__options')?.dataset.subscriptionOnly === 'true') {
      const [id, allocation] = Object.entries(plans)[0] || [];
      const input = form.querySelector('input[name="selling_plan"]');
      const note = form.querySelector('[data-refill-note]');
      if (input) input.value = id || '';
      if (note) note.textContent = allocation?.name?.replace(/^Ships every\s*/i, 'Refills every ') || 'Subscription unavailable';
      const submit = form.querySelector('.buybox__submit');
      if (submit) submit.disabled = !id || variant.disabled;
      return;
    }
    let fitting = null;

    form.querySelectorAll('[data-plan-cadence]').forEach((option) => {
      const input = option.querySelector('input[name="selling_plan"]');
      const applies = !fitting && !!input && !!plans[input.value];
      option.hidden = !applies;
      if (!input) return;
      if (applies) fitting = input;
      else input.checked = false;
    });

    const group = form.querySelector('.buybox__purchase');
    if (group) group.hidden = !fitting;

    if (!form.dataset.purchase && form.querySelector('.buybox__options')?.dataset.defaultPurchase === 'onetime') {
      form.dataset.purchase = 'onetime';
    }
    const oneTime = form.querySelector('input[name="selling_plan"][value=""]');
    if (fitting && form.dataset.purchase !== 'onetime') fitting.checked = true;
    else if (oneTime) oneTime.checked = true;
  }

  /* Keeps the button price in step with the pack and plan. */
  function syncCartPrice(form) {
    const variant = form.querySelector('.buybox__radio:checked');
    if (!variant) return;
    const price = form.querySelector('[data-cart-price]');
    const compare = form.querySelector('[data-cart-compare]');

    let plans = {};
    try {
      plans = JSON.parse(variant.dataset.planData || '{}');
    } catch {}

    /* Resolve the plan before pricing, or the CTA quotes the option that was just replaced. */
    choosePlan(form, variant, plans);

    const plan = form.querySelector('.buybox__options')?.dataset.subscriptionOnly === 'true'
      ? form.querySelector('input[name="selling_plan"]')
      : form.querySelector('input[name="selling_plan"]:checked');
    let shown = variant.dataset.price || '';
    let struck = variant.dataset.compare || '';

    const chosen = plan && plan.value ? plans[plan.value]?.money : null;
    if (chosen) {
      struck = struck || shown;
      shown = chosen;
    }

    if (price) price.textContent = shown;
    if (compare) compare.textContent = struck;
    const stickyPrice = form.closest('.buybox__slide')?.querySelector('[data-sticky-price]');
    const stickyCompare = form.closest('.buybox__slide')?.querySelector('[data-sticky-compare]');
    if (stickyPrice) stickyPrice.textContent = shown;
    if (stickyCompare) stickyCompare.textContent = struck;

    /* Each pack quotes its own plan, so every card agrees with the button. */
    const subscribing = !!(plan && plan.value);
    form.querySelectorAll('.buybox__radio').forEach((radio) => {
      const card = form.querySelector(`label[for="${radio.id}"]`);
      if (!card) return;
      let map = {};
      try {
        map = JSON.parse(radio.dataset.planData || '{}');
      } catch {}
      const onPlan = subscribing ? Object.values(map)[0] : null;
      const now = card.querySelector('[data-pack-price]');
      const was = card.querySelector('[data-pack-was]');
      if (now) now.textContent = onPlan?.money || radio.dataset.price || '';
      if (was) was.textContent = onPlan ? radio.dataset.compare || radio.dataset.price || '' : radio.dataset.compare || '';

      const save = card.querySelector('[data-pack-save]');
      if (!save) return;
      const planCents = onPlan?.cents ?? null;
      const paid = Number(planCents ?? radio.dataset.priceCents);
      const before = Number(planCents ? radio.dataset.compareCents || radio.dataset.priceCents : radio.dataset.compareCents);
      const pct = before > paid ? Math.round(((before - paid) / before) * 100) : 0;
      save.textContent = pct ? `Save ${pct}%` : '';
    });
  }

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.buybox__radio, input[name="selling_plan"]');
    if (!input) return;
    const form = input.closest('form');
    if (!form) return;
    /* Remembered so switching pack does not undo a deliberate one-time choice. */
    if (input.name === 'selling_plan') form.dataset.purchase = input.value ? 'sub' : 'onetime';
    syncCartPrice(form);
  });

  /* Plan options ship hidden, so the first pass is what reveals the ones that fit. */
  document.querySelectorAll('.buybox__form').forEach(syncCartPrice);

  document.querySelectorAll('.buybox--pdp .buybox__form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      const submit = form.querySelector('.buybox__submit');
      if (!submit || submit.disabled) return;

      const data = new FormData(form);
      const id = Number(data.get('id'));
      if (!id) return;

      const plan = data.get('selling_plan');
      const error = form.querySelector('.buybox__checkout-error');
      const spinner = submit.querySelector('.buybox__submit-spinner');
      const buttonContent = submit.querySelectorAll('.buybox__submit-label, .buybox__submit-price, .buybox__submit-was');
      const root = window.Shopify?.routes?.root || '/';
      let previousCart;
      let cartMutationStarted = false;
      if (error) error.hidden = true;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submit.setAttribute('aria-label', 'Processing order');
      buttonContent.forEach((part) => { part.hidden = true; });
      if (spinner) spinner.hidden = false;

      try {
        const snapshot = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!snapshot.ok) throw new Error('Cart could not be read');
        previousCart = await snapshot.json();

        cartMutationStarted = true;
        const cleared = await fetch(`${root}cart/clear.js`, { method: 'POST', headers: { Accept: 'application/json' } });
        if (!cleared.ok) throw new Error('Cart could not be cleared');

        const item = { id, quantity: 1 };
        if (plan) item.selling_plan = Number(plan);
        const added = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] }),
        });
        if (!added.ok) throw new Error('Product could not be added');
      } catch {
        let restored = true;
        if (cartMutationStarted) {
          try {
            const reset = await fetch(`${root}cart/clear.js`, { method: 'POST', headers: { Accept: 'application/json' } });
            if (!reset.ok) throw new Error('Cart could not be reset');
            if (previousCart?.items?.length) {
              const items = previousCart.items.map((line) => ({
                id: line.variant_id,
                quantity: line.quantity,
                properties: line.properties || {},
                ...(line.selling_plan_allocation?.selling_plan?.id ? { selling_plan: line.selling_plan_allocation.selling_plan.id } : {}),
              }));
              const response = await fetch(`${root}cart/add.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items }),
              });
              if (!response.ok) throw new Error('Cart could not be restored');
            }
          } catch {
            restored = false;
          }
        }
        if (error) {
          error.textContent = restored
            ? 'Checkout could not start. Please try again.'
            : 'Checkout could not start. Please check your cart before trying again.';
          error.hidden = false;
        }
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
        submit.removeAttribute('aria-label');
        buttonContent.forEach((part) => { part.hidden = false; });
        if (spinner) spinner.hidden = true;
        return;
      }
      window.location.assign('/checkout');
    }, true);
  });

  /* The sticky bar appears only after its own CTA has left the top of the screen, so it never
     covers the buy box it duplicates. Hidden until observed, so it cannot flash without JS. */
  document.querySelectorAll('.buybox__slide').forEach((slide) => {
    const bar = slide.querySelector('[data-sticky-bar]');
    const cta = slide.querySelector('.buybox__submit');
    if (!bar || !cta || !('IntersectionObserver' in window)) return;

    bar.hidden = false;
    new IntersectionObserver(
      ([entry]) => {
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
      },
      { threshold: 0 }
    ).observe(cta);

    /* Lands the CTA on the bottom edge, so the packs and price above it fill the screen.
       The href alone would put the packs at the top and push the CTA off; this corrects that. */
    const jump = bar.querySelector('.buybox__sticky-cta');
    if (!jump) return;
    jump.addEventListener('click', (event) => {
      event.preventDefault();
      const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      cta.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'end' });
    });
  });

  /* Two shapes over one markup: below 1024px the frames are a swipe rail, above it the radios switch
     a stacked frame and the steppers walk the strip. Either way the current image is the checked
     radio, so both halves read and write the same state. */
  document.querySelectorAll('.buybox__gallery').forEach((gallery) => {
    const stage = gallery.querySelector('.buybox__stage');
    const rail = gallery.querySelector('.buybox__rail');
    const frames = gallery.querySelectorAll('.buybox__frame');
    const radios = gallery.querySelectorAll('.buybox__frame-radio');
    const thumbs = gallery.querySelectorAll('.buybox__thumb');
    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    if (!stage || frames.length < 2) return;

    const swipes = window.matchMedia('(max-width: 1023px)');
    const still = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const pitch = () => frames[0].offsetWidth + (parseFloat(getComputedStyle(stage).columnGap) || 0);
    const chosen = () => Math.max([...radios].findIndex((radio) => radio.checked), 0);

    const sync = () => {
      const shown = swipes.matches ? Math.round(stage.scrollLeft / pitch()) : chosen();
      thumbs.forEach((thumb, index) => {
        if (index === shown) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      /* Keeps the radios in step, so a swipe survives a rotation into the desktop layout. */
      if (radios[shown]) radios[shown].checked = true;
      if (prev) prev.disabled = shown <= 0;
      if (next) next.disabled = shown >= frames.length - 1;
    };

    /* Centres the thumbnail, so the strip follows the steppers once it is too wide to sit still. */
    const step = (delta) => {
      const shown = Math.min(Math.max(chosen() + delta, 0), frames.length - 1);
      radios[shown].checked = true;
      const thumb = thumbs[shown];
      if (thumb) {
        rail.scrollTo({
          left: thumb.offsetLeft - (rail.clientWidth - thumb.offsetWidth) / 2,
          behavior: still() ? 'auto' : 'smooth',
        });
      }
      sync();
    };

    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));

    gallery.addEventListener('change', sync);
    stage.addEventListener('scroll', sync, { passive: true });
    swipes.addEventListener('change', sync);
    sync();
  });

  class ProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.prev = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      if (!this.track || !this.prev || !this.next) return;

      this.prev.addEventListener('click', () => this.scrollBySlide(-1));
      this.next.addEventListener('click', () => this.scrollBySlide(1));
      this.track.addEventListener('scroll', () => this.syncControls(), { passive: true });
      this.syncControls();
    }

    scrollBySlide(direction) {
      const slide = this.track.querySelector('.buybox__slide');
      if (!slide) return;
      this.track.scrollBy({ left: direction * (slide.offsetWidth + this.gap()), behavior: 'smooth' });
    }

    gap() {
      return parseFloat(getComputedStyle(this.track).columnGap) || 0;
    }

    syncControls() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.prev.disabled = this.track.scrollLeft <= 1;
      this.next.disabled = this.track.scrollLeft >= max - 1;
    }
  }

  customElements.define('product-carousel', ProductCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  /* Steps the quantity and submits, so the count is not stranded behind Update cart. */
  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-qty-step]');
    if (!step) return;
    const input = step.parentElement.querySelector('.stepper__input');
    if (!input) return;
    const next = Math.max(0, Number(input.value || 0) + Number(step.dataset.qtyStep));
    if (String(next) === input.value) return;
    input.value = next;
    input.form?.requestSubmit(input.form.querySelector('[name="update"]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /* Submitting on change keeps sorting to one interaction. The noscript button covers the rest. */
  document.addEventListener('change', (event) => {
    if (event.target.matches('.collection__select')) event.target.form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-wall"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-reviews-direction]');
    if (!button) return;
    const carousel = button.closest('.reviews--reference-top')?.querySelector('.reviews-marquee');
    const card = carousel?.querySelector('.reviews-marquee__item');
    if (!card) return;
    const direction = Number(button.dataset.reviewsDirection);
    carousel.scrollBy({ left: direction * (card.getBoundingClientRect().width + 16), behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
